import { Injectable, signal } from '@angular/core';
import { FlashMessage } from './flash-message.model';

@Injectable({providedIn: 'root'})
export class FlashMessagesService {
    messages = signal<Array<FlashMessage>>([]);

    close(message: FlashMessage): void {
        this.messages.set(this.messages().filter(m => m !== message));
    }

    danger(title: string, message: string, config: Partial<FlashMessage> = {}): void {
        this.add({
            ...config,
            severity: 'danger',
            icon: 'fa-regular fa-times-circle',
            summary: title,
            detail: message,
        });
    }

    info(title: string, message: string, config: Partial<FlashMessage> = {}): void {
        this.add({
            ...config,
            severity: 'info',
            icon: 'fa-regular fa-exclamation-circle',
            summary: title,
            detail: message,
        });
    }

    success(title: string, message: string, config: Partial<FlashMessage> = {}): void {
        this.add({
            ...config,
            severity: 'success',
            icon: 'fa-regular fa-check-circle',
            summary: title,
            detail: message,
        });
    }

    warning(title: string, message: string, config: Partial<FlashMessage> = {}): void {
        this.add({
            ...config,
            severity: 'warning',
            icon: 'fa-regular fa-exclamation-triangle',
            summary: title,
            detail: message,
        });
    }

    private add(message: FlashMessage): void {
        this.messages.update((messages: Array<FlashMessage>) => ([...messages, {
            delay: message.delay || 5000,
            autohide: message.autohide || true,
            ...message,
        }]));
    }
}
